// extracted by mini-css-extract-plugin
export default {"hot":"index_hot_OzBwG clearfix","title":"index_title_t5-9l","box_01_1":"index_box_01_1_BRWWc","text":"index_text_aieKa"};